<template lang='pug' src='./accessibility.pug'></template>

<script>
import Loader from 'components/loader/loader'

export default {
  name: 'Accessibility',
  created () {
    if (!this.$route.hash) {
      this.$store.dispatch('VIEW_NAV', 0)
    }
  },
  computed: {
    props () {
      return this.$store.state.pages['accessibility']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader
  },
  data () {
    return {
      companyName: 'Seattle Orthodontics', // Fill this in
      domain: "<a href='https://seattle-orthodontics.com'>seattle-orthodontics.com</a>", // Fill this in
      email: "<a href='mailto:info@loveortho.com'>info@loveortho.com</a>", // Fill this in
      phone: "<a href='tel:+12065257000'>(206) 525-7000</a>", // Fill this in
      formattedEmail: ''
    }
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  }
}
</script>

<style lang="sass" src="./accessibility.sass"></style>



// WEBPACK FOOTER //
// accessibility.vue?6f8bea89